import { trigger, state, style, transition, animate } from '@angular/animations';

export const FadeStateAnimation = trigger('fadeState', [
  state('inactive', style({opacity: 0, top: '-10000px'})),
  state('active', style({opacity: 1})),
  transition('inactive => active', [
    style({opacity: 0, top: ''}),
    animate('0.4s', style({opacity: 1}))
  ]),
  transition('active => inactive', [
    style({opacity: 1}),
    animate('0.4s', style({opacity: 0}))
  ])
]);


// WEBPACK FOOTER //
// ./src/app/shared/fade-state.animation.ts